// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Feilkode:",
    "error.search": "Søk I kunnskapsdatabasen vår for å finne ut mer",
    dismiss: "forkast",
    "installation.title": "",
    "cancelation.button": "Avbryt",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Initialisering mislyktes",
      description: "Vi kan ikke gjengi siden. Ta kontakt med støtten.",
    },
    "EOS-UI-UE": {
      title: "Noe gikk galt.",
      description: "Noe gikk galt. Ta kontakt med støtten.",
    },
    "EOS-IN-BC": {
      title: "Installasjon mislyktes",
      description:
        "Vi kan ikke vise installasjonsfremdriften. Ta kontakt med støtten.",
    },
    "EOS-IN-UE": {
      title: "Installasjon mislyktes",
      description: "Noe gikk galt. Ta kontakt med støtten.",
    },
    "EOS-IN-FF": {
      title: "Installasjon mislyktes",
      description:
        "Vi kan ikke koble til Epic Online Services. Ta kontakt med støtten.",
    },
    "EOS-IN-FF-*": {
      title: "Installasjon mislyktes",
      description:
        "Vi kan ikke utføre forespørselen til Epic Online Services. Ta kontakt med støtten.",
    },
    fallback: {
      title: "Noe gikk galt.",
      description: "Noe gikk galt. Ta kontakt med støtten.",
    },
  },
};
